import React, {useState, useEffect} from "react";
import { Switch, Route, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import AuthService from "./Services/auth.service";
/*Import Pages*/
import Login from "./Pages/login.page";
import Register from "./Pages/register.page";
import Home from "./Pages/home.page";
import Profile from "./Pages/profile.page";
import BoardUser from "./Pages/board-user.page";
import BoardModerator from "./Pages/board-moderator.page";
import BoardAdmin from "./Pages/board-admin.page";
/*Import Assets*/
import Exit from './Assets/Icons/exit.png';
import Foodiary from "./Pages/fo.diary.page";
import Wodiary from "./Pages/wo.diary.page";
import Exelibrary from "./Pages/ex.diary.page";
import Goalslib from "./Pages/go.diary.page";

import dacminlogo from "./Assets/Images/dacminott.png";

const App=()=> {
  
  const [showModeratorBoard, setshowModeratorBoard]= useState(false);
  const [showAdminBoard, setshowAdminBoard]= useState(false);
  const [currentUser, setcurrentUser]= useState(undefined);
  const [showHome, setshowHome]= useState(false);
  
  useEffect(() => {
    const user =AuthService.getCurrentUser();

    if(user) {
      setcurrentUser(user);
      setshowModeratorBoard(user.roles.includes("ROLE_MODERATOR"));
      setshowAdminBoard(user.roles.includes("ROLE_ADMIN"));
      setshowHome(false);
    }
  },[]);

  const logOut=()=> {AuthService.logout();}


  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);


  return(
    <div className="container-fluid fullwidth colorbody">
        <nav className="navbar navbar-expand-lg navbar-dark colorgrad">
          <div className="container-fluid">
            <Link to={"/"} className="navbar-brand">
              {/**/}
              <img src={dacminlogo} width='40' height='40'></img>
            </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded={!isNavCollapsed ? true : false} aria-label="Toggle navigation" onClick={handleNavCollapse}>
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarSupportedContent">
            

            {currentUser ? (
              <div className="navbar-nav ml-auto">
                <li className="nav-item">
                  <Link to={"/profile"} className="nav-link ct">
                    {currentUser.firstname}
                  </Link>
                </li>
                <li className="nav-item">
                  <a href="/login" className="nav-link ct" onClick={logOut}>
                    <img src={Exit} className="" width="24" height="20"/>
                  </a>
                </li>
              </div>
            ) : (
              <div className="navbar-nav ml-auto">
                <li className="nav-item">
                  <Link to={"/login"} className="nav-link ct">
                    Login
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to={"/register"} className="nav-link ct">
                    Sign Up
                  </Link>
                </li>
              </div>
            )}
            </div>
          </div>
        </nav>
        <nav className="navbar navbar-expand-lg colornav2">
            <div className="container-fluid">
              <ul className="navbar-nav mx-auto mb-0">{/*me-auto*/}
                {showHome && (
                <li className="nav-item col-md-auto ct2">
                  <Link to={"/home"} className="nav-link ct2">
                    HOME
                  </Link>
                </li>
                )}

                {showModeratorBoard && (
                  <li className="nav-item col-md-auto ct2">
                    <Link to={"/mod"} className="nav-link ct2">
                      MODERATOR BOARD
                    </Link>
                  </li>
                )}

                {showAdminBoard && (
                  <li className="nav-item col-md-auto ct2">
                    <Link to={"/admin"} className="nav-link ct2">
                      ADMIN BOARD
                    </Link>
                  </li>
                )}

                {currentUser && (
                  <li className="nav-item col-md-auto ct2">
                    <Link to={"/user"} className="nav-link ct2">
                      DASHBOARD
                    </Link>
                  </li>
                )}
              </ul>
        </div>
      </nav>

        <div className="container-fluid mt-3">
          <Switch>
            <Route exact path={["/", "/home"]}>
              <Home/>
            </Route>
            <Route exact path="/login"><Login/></Route>
            <Route exact path="/register"><Register/></Route>
            <Route exact path="/profile"><Profile/></Route>
            <Route path="/user"><BoardUser/></Route>
            <Route path="/mod"><BoardModerator/></Route>
            <Route path="/admin"><BoardAdmin/></Route>
            <Route path="/foodiary"><Foodiary/></Route>
            <Route path="/wodiary"><Wodiary/></Route>
            <Route path="/exelibrary"><Exelibrary/></Route>
            <Route path="/goalslib"><Goalslib/></Route>
          </Switch>
        </div>
      </div>
  ) 
}

export default App;
